import React from 'react'
import PropTypes from 'prop-types'

import styles from '../../styles/components/Map/MapMarker.module.css'

const MapMarker = props => (
  <div title={props.label} className={styles.marker}>
    <img src='occupation-area/pin.svg' alt={props.label} />
  </div>
)

MapMarker.propTypes = {
  lat: PropTypes.number,
  lng: PropTypes.number,
  label: PropTypes.string
}

export default MapMarker
